import { useCallback, useMemo, useState } from "react";
import { Checkbox } from "antd";

export const useBulkSelection = (data, { rowKey = "id" } = {}) => {
  const [selectedKeys, setSelectedKeys] = useState([]);

  const allKeys = useMemo(
    () => (data || []).map((item) => item?.[rowKey]).filter((v) => v != null),
    [data, rowKey]
  );

  const isAllSelected =
    allKeys.length > 0 && selectedKeys.length === allKeys.length;

  const isIndeterminate =
    selectedKeys.length > 0 && selectedKeys.length < allKeys.length;

  const toggleAll = useCallback(
    (checked) => {
      if (checked) setSelectedKeys(allKeys);
      else setSelectedKeys([]);
    },
    [allKeys]
  );

  const toggleOne = useCallback((key, checked) => {
    setSelectedKeys((prev) => {
      if (checked) {
        if (prev.includes(key)) return prev;
        return [...prev, key];
      }
      return prev.filter((x) => x !== key);
    });
  }, []);

  const clearSelection = useCallback(() => setSelectedKeys([]), []);

  const getSelectionColumn = useCallback(
    () => ({
      title: (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Checkbox
            indeterminate={isIndeterminate}
            checked={isAllSelected}
            onChange={(e) => {
              e.stopPropagation();
              toggleAll(e.target.checked);
            }}
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      ),
      dataIndex: "__select",
      key: "__select",

      width: '1%',

      className: "lf-col-select",
      onHeaderCell: () => ({ className: "lf-col-select" }),
      onCell: () => ({ className: "lf-col-select" }),

      render: (_, record) => {
        const key = record?.[rowKey];
        const checked = selectedKeys.includes(key);

        return (
          <div
            className={
              "lf-bulk-checkbox-wrapper" +
              (checked ? " lf-bulk-checkbox-wrapper--selected" : "")
            }
            onClick={(e) => e.stopPropagation()}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Checkbox checked={checked} onChange={(e) => toggleOne(key, e.target.checked)} />
          </div>
        );
      },
    }),
    [isIndeterminate, isAllSelected, toggleAll, toggleOne, rowKey, selectedKeys]
  );

  return {
    selectedKeys,
    clearSelection,
    isAllSelected,
    isIndeterminate,
    getSelectionColumn,
    setSelectedKeys
  };
};